var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-section',{attrs:{"loading":_vm.loading,"error":_vm.error,"is-empty":!_vm.items.length,"variant":_vm.commercial ? 'commercial-banner' : 'banner',"skeleton-variant":"banners","skeleton-count":2},on:{"retry":function($event){return _vm.$emit('retry')}}},[_c('home-banner-rail',{attrs:{"items":_vm.items,"commercial":_vm.commercial}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }